import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { lineGroupQueries } from '@/services/premiumStores/lineGroup/lineGroup.queries';

export const useLineGroupDetail = (clubId: string) => {
  const { data, isLoading } = useQuery({
    ...lineGroupQueries.detail({
      clubId: clubId,
    }),

    enabled: !!clubId,
  });
  return {
    data: data?.data || undefined,
    isLoading: isLoading,
  };
};
